import React from 'react';

import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';

import { Feedback } from '@qality/common-components/src/Feedback';
import { PremiumFeatureGuard } from '@qality/common-components/src/atoms/PremiumFeatureGuard';
import { TestStepsView } from '@qality/common-model';

import ChangeView from '../../test-case-box/ChangeView';
import { ContainerStyled } from './NavigateButtons.styled';

type Props = {
  addTestCase?: () => Promise<void>;
  isAddingTestCase?: boolean;
  changeView: (value: TestStepsView) => void;
  expandTestCases?: () => void;
  expanded?: boolean;
  view: TestStepsView;
  canEdit: boolean;
};

const TOOLTIP_COLLAPSE = 'collapse all';
const TOOLTIP_EXPAND = 'expand all';

export default function NavigateButtons({
  addTestCase,
  isAddingTestCase,
  changeView,
  expandTestCases,
  expanded,
  view,
  canEdit,
}: Props): JSX.Element {
  return (
    <ContainerStyled>
      <ButtonGroup>
        {addTestCase && (
          <LoadingButton
            onClick={addTestCase}
            isDisabled={!canEdit}
            isLoading={isAddingTestCase}
          >
            Add Test Case
          </LoadingButton>
        )}
        <ChangeView value={view} onChange={changeView} />
        {expandTestCases && (
          <Tooltip content={expanded ? TOOLTIP_COLLAPSE : TOOLTIP_EXPAND}>
            <Button onClick={expandTestCases}>
              {expanded ? 'Collapse All Test Cases' : 'Expand All Test Cases'}
            </Button>
          </Tooltip>
        )}
      </ButtonGroup>
      <PremiumFeatureGuard
        free={
          <ButtonGroup>
            <Feedback />
          </ButtonGroup>
        }
      />
    </ContainerStyled>
  );
}
